import { render, staticRenderFns } from "./carStructureList.vue?vue&type=template&id=d05a04fa&scoped=true"
import script from "./carStructureList.vue?vue&type=script&lang=js"
export * from "./carStructureList.vue?vue&type=script&lang=js"
import style0 from "./carStructureList.vue?vue&type=style&index=0&id=d05a04fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d05a04fa",
  null
  
)

export default component.exports